import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styled, { css } from 'styled-components';
import { colors, sp } from 'styles/theme';
import { downArrowSvg } from 'images';

// prettier-ignore
const Wrapper = styled.div`
  position: relative;
  margin-right: ${sp.l};

  &:last-child {
    margin-right: 0;
  }

  ${props => props.theme.vertical && css`
    margin-right: 0;
    margin-bottom: ${sp.m};
  `}
`;

// prettier-ignore
const StyledNavItem = styled(Link)`
  display: flex;
  align-items: center;
  font-weight: 600;
  color: ${colors.navy};
  text-decoration: none;
  font-size: 12px;
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 1px;

  ${props => props.theme.vertical && css`
    width: 100%;
    font-size: 18px;
    letter-spacing: 0;
  `}
`;

const Title = styled.div`
  ${props => props.theme.vertical && `margin-bottom: ${sp.s}`};
`;

const StyledNavToggle = StyledNavItem.withComponent('button').extend`
  &:after {
    display: block;
    position: relative;
    top: 2px;
    margin-left: ${sp.s};
    transition: transform 0.3s;
    background: url('${downArrowSvg}') no-repeat;
    width: 13px;
    height: 8px;
    content: '';

    ${props => props.isOpen && 'transform: rotate(-180deg);'};
    ${props => props.theme.vertical && 'display: none;'};
  }
`;

const propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
};

const defaultProps = {
  to: undefined,
  children: undefined,
  isOpen: false,
  onClick: () => {},
};

function NavItem({ isOpen, title, to, onClick, children }) {
  const sharedProps = { onClick };
  const linkProps = { ...sharedProps, to };
  const buttonProps = { ...sharedProps, isOpen };
  const wrappedTitle = <Title>{title}</Title>;
  return (
    <Wrapper>
      {to ? (
        <StyledNavItem {...linkProps}>{wrappedTitle}</StyledNavItem>
      ) : (
        <StyledNavToggle {...buttonProps}>{wrappedTitle}</StyledNavToggle>
      )}

      {children}
    </Wrapper>
  );
}

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/components/NavItem.jsx